import type {
  Progress,
  UiPrefs,
  User,
  AchievementsState,
  CapstoneState,
  CapstoneArtifactProgress,
} from '@/types';

export const defaultUiPrefs = (): UiPrefs => ({
  theme: 'warmsunset',
  density: 'cosy',
  decoration: 'playful',
  fontScale: 'base',
});

export const defaultUser = (): User => ({
  id: 'local-user',
  displayName: 'инженер',
  locale: 'ru',
  timezone:
    typeof Intl !== 'undefined' && typeof Intl.DateTimeFormat === 'function'
      ? Intl.DateTimeFormat().resolvedOptions().timeZone
      : 'Europe/Istanbul',
  createdAt: new Date().toISOString(),
});

export const defaultAchievements = (): AchievementsState => ({
  earned: [],
  progress: {},
  hidden: [],
  buddySkin: { equippedSkin: 'default', unlockedSkins: ['default'] },
  accentOverlay: { selected: 'default', unlocked: ['default'] },
  miniLessons: { unlocked: [], readAt: {}, readingProgress: {}, quizPacksSolved: {} },
  pomodoroSessions: [],
  themeUsage: {},
  localeUsage: {},
  seniorExtensionsOpened: {},
  activityByDay: {},
});

const emptyArtifact = (): CapstoneArtifactProgress => ({ submitted: false });

export const defaultBlock1Capstone = (): CapstoneState => ({
  capstoneId: 'block-1',
  artifacts: {
    'test-plan': emptyArtifact(),
    'test-cases': emptyArtifact(),
    'bug-reports': emptyArtifact(),
    rtm: emptyArtifact(),
    tsr: emptyArtifact(),
    journal: emptyArtifact(),
  },
  rubricRequired: {
    'r-test-plan-exit-criteria': false,
    'r-tc-template-fields': false,
    'r-tc-three-techniques': false,
    'r-br-severity-priority-pairs': false,
    'r-no-duplicate-bugs': false,
    'r-rtm-coverage-80': false,
    'r-tsr-go-no-go': false,
    'r-journal-3-entries': false,
    'r-ctfl-mock2-65': false,
  },
  rubricBonus: {
    'b-master-documenter': false,
    'b-test-case-champion': false,
    'b-bug-hunter': false,
    'b-plan-pro': false,
    'b-reflective-practitioner': false,
    'b-tsr-architect': false,
    'b-atelier-resident': false,
    'b-a11y-aware': false,
    'b-capstone-champion': false,
  },
});

export const defaultProgress = (): Progress => ({
  last: {
    sprintId: 'S01',
    timestamp: new Date().toISOString(),
  },
  sprints: {},
  tickets: {},
  homework: {},
  skills: {},
  onboarding: {
    sprint0TourCompleted: false,
    dashboardSeen: false,
    themeSwitcherTried: false,
    welcomeSeen: false,
  },
  cockpit: {
    mockHistory: {},
    flashcards: {},
  },
  achievements: defaultAchievements(),
  capstone: {},
});
